import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=02c97b30&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c97b30",
  null
  
)

export default component.exports